import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React from "react";
import { InPageEditingProvider } from "./InPageEditingContext";
import { SectionTemplate } from "./SectionTemplate";
import { Section } from "./types";

interface DetailSectionTemplateProps {
  isInPageEditable: boolean;
  sections: Array<Section>;
  onValueChanged: (key: string, value: any) => (Promise<void> | void);
  onSuccessfulUpdate?: (key: string, newValue: any) => Promise<void>;
  className?: string;
  displayEmptyValues?: boolean;

  wideLabel?: boolean;
}

export const DetailSectionTemplate = (props: DetailSectionTemplateProps) => {
  const { isInPageEditable, sections } = props;

  const validators = useValidators();

  return <div className={props.className}>
    <InPageEditingProvider
      enabled={isInPageEditable}
      validate={validators.validateAll}
      onValueChanged={props.onValueChanged}
      onSuccessfulUpdate={props.onSuccessfulUpdate}
    >
      <ValidatorContext settings={validators.validatorSettings}>
        <SectionTemplate
          isInPageEditable={isInPageEditable}
          sections={sections}
          displayEmptyValues={props.displayEmptyValues}
          wideLabel={props.wideLabel}
        />
      </ValidatorContext>
    </InPageEditingProvider>
  </div>
}